import type { ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { dateRangeToShortString } from "../../../../utilities/dateRangeToShortString.ts";
import FieldCaptionWrapper from "../conditions/FieldCaptionWrapper.tsx";
import type { FieldCaptionIcon } from "../fields/field-captions/FieldsCaptionIconSetContainer.tsx";
import MeasureDimensionCaption from "../fields/field-captions/MeasureDimensionCaption.tsx";

export function formatMeasureCaption(
  measure: ReportField | undefined,
  captionColor?: string,
  iconsSet?: FieldCaptionIcon[],
  caption?: string
) {
  if (measure === undefined) {
    return <></>;
  }
  const customCaption = dateRangeToShortString(measure.config.dateRange);

  return (
    <FieldCaptionWrapper
      Caption={<MeasureDimensionCaption field={measure} captionColor={captionColor} caption={caption} />}
      subCaption={customCaption}
      fieldCaptionIcons={iconsSet}
    />
  );
}

export const getMeasureCaption = (measure: ReportField | undefined) => {
  if (measure === undefined) {
    return "";
  }
  return measure.config.customLabel || measure.meta.caption;
};
